import { render } from "./UserModal.vue?vue&type=template&id=3146a210"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"
script.render = render

export default script